export default __webpack_public_path__ + "static/media/MulticalDark.7849493c.svg";